import toast from "react-hot-toast";

export const showWarningToast = (message, options = {}) =>
  toast(message, {
    icon: "⚠️",
    ...options,
  });
